<template>
  <v-container>
    <v-row justify-md="space-between">
      <v-col cols="12" md="auto">
        <v-btn
          @click="openFormDialog"
          class="accent shadow-4 px-8"
          color="success"
          large
          rounded
        >
          Añadir configuración
        </v-btn>
      </v-col>
    </v-row>

    <v-card class="shadow-1 mt-5">
      <v-data-table
        :search="search"
        :headers="headers"
        :items="webrRtcConfigList"
        item-key="id"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <!-- <template v-slot:item.name="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar
                size="40"
                tile
              >
                <v-avatar
                    size="40"
                    :color="
                      $vuetify.theme.dark
                        ? 'blue-grey darken-4'
                        : 'blue-grey lighten-5'
                    "
                  >
                    <v-img
                      v-if="item.url_image"
                      :src="item.url_image"
                      alt="Avatar del usuario"
                    ></v-img>
                    <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                  </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template> -->

        <template v-slot:[`item.start`]="{ item }">
          <span>{{ item.start | dateFormat }}</span>
        </template>

        <template v-slot:[`item.end`]="{ item }">
          <span>{{ item.end | dateFormat }}</span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <!-- <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="handleShow(item.id)"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </v-hover> -->

          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="handleEdit(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'error' : 'blue-grey'"
              @click.stop="handleDelete(item.id)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-card>

    <newForm
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :dataToEdit="dataToEdit"
      :isEditMode="isEditMode"
      @close:dialog="closeFormDialog"
    ></newForm>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
// import newForm from "./newForm.vue";
import newForm from "@/views/app/clientSettings/webRtcConfig/newForm.vue";

export default {
  components: {
    newForm,
  },

  data: () => ({
    isLoading: false,
    isOpenForm: false,
    isEditMode: false,
    surveyIDSelected: null,
    // For pagination
    totalItems: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
    },
    // End for pagination
    webrRtcConfigList: [],
    dataToEdit: {},
    search: "",
    headers: [
      {
        text: "Public Identity",
        align: "left",
        value: "public_identity",
        class: "primary--text",
        width: "30%",
      },
      // {
      //   text: "Extensión",
      //   value: "extension",
      //   class: "primary--text",
      //   width: "15%",
      // },
      {
        text: "Usuario",
        value: "user.name",
        class: "primary--text",
        width: "25%",
      },
      // {
      //   text: "Estado",
      //   value: "status",
      //   class: "primary--text",
      //   width: "15%",
      // },
      // {
      //   text: "Creado",
      //   align: "left",
      //   value: "created_at",
      //   class: "primary--text",
      //   width: "15%",
      // },
      {
        text: "Acciones",
        value: "action",
        class: "primary--text",
        width: "15%",
        align: "left",
        sortable: false,
      },
    ],
  }),

  watch: {
    options: {
      handler() {
        this.getWebRtcConfig();
      },
      deep: true,
    },
  },

  created() {
    this.getWebRtcConfig();
  },

  methods: {
    openFormDialog() {
      this.isOpenForm = true;
    },

    closeFormDialog(payload) {
      this.isOpenForm = false;
      this.dataToEdit = {};
      this.isEditMode = false;

      if (payload) this.getWebRtcConfig();
    },

    handleEdit(item) {
      this.isEditMode = true;
      this.dataToEdit = item;
      this.openFormDialog();
    },

    // handleShow(SurveyId) {
    //   this.$router.push({
    //     name: "Detalles de formulario",
    //     params: { SurveyId },
    //   });
    // },

    // handleInfo(SurveyId) {
    //   this.$router.push({
    //     name: "Resultados formularios",
    //     params: { SurveyId },
    //   });
    // },

    async handleDelete(id) {
      try {
        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `Está seguro de eliminar este evento? Ésta acción no es reversible.`
        );
        if (confirmRequest.isConfirmed) {
          PbxHttpClient.delete(`/admin/webrtc/${id}`)
            .then((res) => {
              const index = this.webrRtcConfigList.findIndex((el) => el.id === id);
              this.webrRtcConfigList.splice(index, 1);

              this.$snotify.success("configuración eliminada", "¡Hecho!");
            })
            .catch((error) => {
              // console.error(error);
              this.$snotify.error("Hubo un error al eliminar.", "Error");
            });
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar la configuración.", "¡Error!");
        // console.error(error);
      }
    },

    // closeFormDialog(data = false) {
    //   if (data && this.isEditMode)
    //     this.webrRtcConfigList = this.webrRtcConfigList.map((el) =>
    //       el.id === data.id ? data : el
    //     );
    //   if (data && !this.isEditMode)
    //     this.webrRtcConfigList = [...this.webrRtcConfigList, data];
    //   this.isOpenForm = false;
    //   this.isEditMode = false;
    //   this.dataToEdit = {};
    // },

    async getWebRtcConfig() {
      this.isLoading = true;

      const { page, itemsPerPage } = this.options;

      await PbxHttpClient.get(`/admin/webrtc/`, {
        params: { page, itemPerPage: itemsPerPage },
      })
        .then((res) => {
          this.webrRtcConfigList = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
